import React from 'react';
import Modal from '../Modal';
import { fireEvent, render, screen } from '@testing-library/react';

describe('Modal Component', () => {
  it('it renders its children', () => {
    const links = ['1', '2', '3', '4', '5'];
    const anchorLinks = links.map((link, index) =>
      <a key={index}>{link}</a>
    );
    const onClose = jest.fn();
    render(
      <Modal onClose={onClose}>
        <div>
          {anchorLinks}
        </div>
      </Modal>
    );
    links.forEach(link =>
      expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'a' && content === link)).toBeInTheDocument()
    );
  });

  it('it calls onClose', () => {
    const onClose = jest.fn();
    render(<Modal onClose={onClose} />);
    fireEvent.click(screen.getByTestId('modal'));
    expect(onClose).toHaveBeenCalledTimes(1);
  });
});
